import React from 'react';
import { Checkbox } from 'src/client/components/recruitments/Checkbox';
import { useRecruitmentListContext } from 'client/contexts/recruitments/RecruitmentList';
import { WorkingHourOption } from 'src/client/generated';

type Props = {
  workingHourOptions: WorkingHourOption[];
};

export const WorkingHourOptionList = ({ workingHourOptions }: Props) => {
  const {
    searchQueryParams: { workingHourOptionIds },
    dispatch,
  } = useRecruitmentListContext();

  return (
    <div className="mx-0 my-6">
      {workingHourOptions.length > 0 &&
        workingHourOptions.map(
          (option) =>
            option && (
              <div
                key={option.id}
                className="w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray"
                onClick={() =>
                  dispatch({
                    type: 'changeWorkingHourOptionIds',
                    payload: { workingHourOptionId: option.id },
                  })
                }
                data-testid={`working-hour-option-checkbox-${option.id}`}
              >
                <Checkbox
                  label={option.name}
                  checked={workingHourOptionIds?.includes(option.id) || false}
                  onClick={() => {}}
                />
                <div className="divider"></div>
              </div>
            ),
        )}
    </div>
  );
};
